import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Header from "../../components/Layout/Header/Header";
import Footer from "../../components/Layout/Footer/Footer";
import ScrollToTop from "../../components/Common/ScrollTop";
import OffWrap from "../../components/Layout/Header/OffWrap";
import SiteBreadcrumb from "../../components/Common/Breadcumb";
import SearchModal from "../../components/Layout/Header/SearchModal";
import footerLogo from "../../assets/img/logo/jntua-logo.png";
import { fetchData } from "../../utils/fetchData";
import Accreditation from "../../components/Common/Accreditation";
import { AcademicsMenu } from "../../components/Common/SidebarMenu";
import SideBar from "../../components/Common/SideBar";
import { useParams } from "react-router-dom";
import RightSidebar from "../../components/Common/RightSidebar";
import { useFontSize } from "../../FontSizeContext";
import Pagination from "../../components/Pagination";
import { BlocksRenderer } from "../../components/BlockRenderer";
const getLabelObj = (data) => {
  if (
    data?.data?.[0]?.attributes?.Course_Short_Form?.data?.attributes?.Degree ===
    "Under Graduate"
  )
    return {
      label: "UG - Programmes Offered - Affiliated",
      path: "under-graduate",
    };
  else
    return {
      label: "PG - Programmers Offered - Affiliated",
      path: "post-graduate",
    };
};
const Courses = () => {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(25);
  const totalItems = data?.meta?.pagination?.total;
  const { id } = useParams();
  const { fontSize } = useFontSize();
  useEffect(() => {
    fetchData(
      `/course-branches?populate=*&filters[Course_Short_Form][id][$eq]=${id}&pagination[page]=${currentPage}`,
      setData
    );
  }, [id, currentPage]);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  return (
    <React.Fragment>
      <Helmet>
        <title>Autonomous Colleges | JNTU Anantapur</title>
        <meta
          name="description"
          content="Autonomous Colleges Jawaharlal Nehru Technological University Anantapur"
        />
        <meta
          name="keywords"
          content="Autonomous Colleges Jawaharlal Nehru Technological University Anantapur"
        ></meta>
      </Helmet>
      <OffWrap />
      <Header
        parentMenu="home"
        TopBar="enable"
        TopBarClass="topbar-area dark-primary-bg hidden-lg"
      />
      <style>
        {`
                    body,
                    .rs-latest-events.style1 .event-wrap .events-short .date-part .date,
                    .widget ul li a {
                        font-size: ${fontSize}px;
                    }
                    .rs-inner-blog .blog-item .blog-content .blog-title,
                    .widget h1,.content-wrapper h2, .heading, .college-title{
                        font-size: calc(${fontSize}px + 10px);
                    }
                    .breadcrumb-bg .breadcrumbs-text ul li{
                      font-size: calc(${fontSize}px + 2px);
                    }
                    
                    .full-width-header .rs-header .topbar-area .topbar-right li.login-register a,
                    .readon.orange-btn, .rs-latest-events.bg-wrap .notification-filter button,
                    .rs-latest-events.style1 .event-wrap:not(.ls-area) .events-short .slNo, 
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > a,
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > ul li > a,
                    table th, table td {                       
                        font-size: calc(${fontSize}px - 2px);
                    }

                    .rs-footer .footer-top-social .social_msg{
                        font-size: calc(${fontSize}px + 18px);
                    }
                    .rs-footer .footer-center h3{
                        font-size: calc(${fontSize}px + 12px);
                    }
                    .rs-footer.home9-style .footer-top .widget-title,
                    .rs-team.style1 .about-btn--primary,
                    .rs-team.style1 .about-btn--secondary,
                    .course-overview .inner-box h5{
                        font-size: calc(${fontSize}px + 4px);
                    }
                    .rs-footer .footer-center h4,
                    .rightBar h4{
                        font-size: calc(${fontSize}px + 6px);
                    }
                    
                `}
      </style>
      <div className="pageTopOffset">
        {/* breadcrumb-area-start */}
        <SiteBreadcrumb
          pageCategory={getLabelObj(data)}
          pageName={
            data?.data?.[0]?.attributes?.Course_Short_Form?.data?.attributes
              ?.Course_Full_Form || ""
          }
        />
        {/* breadcrumb-area-start */}

        <div id="rs-about" className="rs-about style3 pt-50 pb-50 md-pt-30">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 xl-mb-30">
                <div className="about-intro">
                  <AcademicsMenu />
                  <SideBar />
                </div>
              </div>
              <div className="col-xl-6 pl-20 xl-pl-14">
                <div className="row">
                  <div className="rs-inner-blog col-lg-12">
                    <h3 className="college-title">
                      {data?.data?.[0]?.attributes?.Course_Short_Form?.data
                        ?.attributes?.Course_Full_Form || ""}
                    </h3>
                    <div style={{ marginBottom: "20px" }}>
                      <BlocksRenderer
                        content={
                          data?.data?.[0]?.attributes?.Course_Short_Form?.data
                            ?.attributes?.Body || []
                        }
                      />
                    </div>
                    <div className="overflow-x">
                      <table className="table table-striped table-bordered">
                        <thead>
                          <tr>
                            <th scope="col">S.No</th>
                            <th scope="col">
                              {getLabelObj(data)?.path === "post-graduate"
                                ? "Department/Centre"
                                : "Course"}
                            </th>
                            <th scope="col">
                              Specialization Name / Branch Name
                            </th>
                            <th scope="col">
                              Specialization Code / Branch Code
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {data?.data?.map((obj, index) => (
                            <tr>
                              <td>
                                {((currentPage - 1) * itemsPerPage + index + 1)
                                  .toString()
                                  .padStart(2, "0")}
                                .
                              </td>
                              <td>
                                {getLabelObj(data)?.path === "post-graduate"
                                  ? obj?.attributes?.Department
                                  : obj?.attributes?.Course_Short_Form?.data
                                      ?.attributes?.Course_Short_Form}
                              </td>
                              <td>
                                {
                                  obj?.attributes
                                    ?.Specialization_Name_Or_Branch_Name
                                }
                              </td>
                              <td>
                                {
                                  obj?.attributes
                                    ?.Specialization_Code_Or_Branch_Code
                                }
                              </td>
                            </tr>
                          ))}
                          {data?.data?.length === 0 && (
                            <tr>
                              <td align="center" colSpan={4}>
                                Data not found.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    <Pagination
                      currentPage={currentPage}
                      paginate={paginate}
                      arrayLength={totalItems / itemsPerPage}
                    />
                  </div>
                </div>
              </div>
              <div className="col-xl-3 pl-40 xl-pl-14">
                <RightSidebar />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Accreditation />

      <Footer
        footerClass="rs-footer home9-style main-home"
        footerLogo={footerLogo}
      />

      {/* scrolltop-start */}
      <ScrollToTop scrollClassName="scrollup orange-color" />
      {/* scrolltop-end */}

      <SearchModal />
    </React.Fragment>
  );
};

export default Courses;
